/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetApplicationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetApplications',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationChangedNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.RegisterApplicationChangedNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationChangedNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationRemovedNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.RegisterApplicationRemovedNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationRemovedNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartApplicationScan: BridgeCommands.Command<
    Types.Nvapp.Localgames.StartApplicationScanParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'StartApplicationScan',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationScanProgressNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.RegisterApplicationScanProgressNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationScanProgressNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLastApplicationScanTime: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetLastApplicationScanTimeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetLastApplicationScanTime',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LaunchApplication: BridgeCommands.Command<
    Types.Nvapp.Localgames.LaunchApplicationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'LaunchApplication',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LaunchApplicationByPath: BridgeCommands.Command<
    Types.Nvapp.Localgames.LaunchApplicationByPathParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'LaunchApplicationByPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLauncherPID: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetLauncherPIDReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetLauncherPID',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplicationSearchPaths: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetApplicationSearchPathsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetApplicationSearchPaths',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AddApplicationSearchPath: BridgeCommands.Command<
    Types.Nvapp.Localgames.AddApplicationSearchPathParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'AddApplicationSearchPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RemoveApplicationSearchPath: BridgeCommands.Command<
    Types.Nvapp.Localgames.RemoveApplicationSearchPathParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RemoveApplicationSearchPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBatteryBoostState: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.BatteryBoostState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetBatteryBoostState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBatteryBoostState: BridgeCommands.Command<
    Types.Nvapp.Localgames.BatteryBoostState,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetBatteryBoostState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBatteryBoostSupportState: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetBatteryBoostSupportStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetBatteryBoostSupportState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIsSystemOPSCompatible: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetIsSystemOPSCompatibleReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetIsSystemOPSCompatible',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIsMultiGPUInferenceSupported: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetIsMultiGPUInferenceSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetIsMultiGPUInferenceSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWhisperModeState: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.WhisperModeState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetWhisperModeState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetWhisperModeState: BridgeCommands.Command<
    Types.Nvapp.Localgames.SetWhisperModeStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetWhisperModeState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWhisperModeInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetWhisperModeInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetWhisperModeInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterWhisperModeStateNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.WhisperModeState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterWhisperModeStateNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWhisperModeSupportState: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.FeatureSupportState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetWhisperModeSupportState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterWhisperModeSupportStateNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.FeatureSupportState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterWhisperModeSupportStateNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSettingsTranslations: BridgeCommands.Command<
    Types.Nvapp.Localgames.GetSettingsTranslationsParameters,
    Types.Nvapp.Localgames.GetSettingsTranslationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetSettingsTranslations',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSettingsSpace: BridgeCommands.Command<
    Types.Nvapp.Localgames.GetSettingsSpaceParameters,
    Types.Nvapp.Localgames.GetSettingsSpaceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetSettingsSpace',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetTargetSettings: BridgeCommands.Command<
    Types.Nvapp.Localgames.SetTargetSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetTargetSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplicationState: BridgeCommands.Command<
    Types.Nvapp.Localgames.GetApplicationStateParameters,
    Types.Nvapp.Localgames.GetApplicationStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetApplicationState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterApplicationStateChangedNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.RegisterApplicationStateChangedNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterApplicationStateChangedNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterMultiGPUStateChangedNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.RegisterMultiGPUStateChangedNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'RegisterMultiGPUStateChangedNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSignedGPUID: BridgeCommands.Command<
    Types.Nvapp.Localgames.GetSignedGPUIDParameters,
    Types.Nvapp.Localgames.GetSignedGPUIDReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetSignedGPUID',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LaunchMSSettings: BridgeCommands.Command<
    Types.Nvapp.Localgames.LaunchMSSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'LaunchMSSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetOOTBStatus: BridgeCommands.Command<
    Types.Nvapp.Localgames.SetOOTBStatusParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetOOTBStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const FindAndGetAppMetadata: BridgeCommands.Command<
    Types.Nvapp.Localgames.FindAndGetAppMetadataParameters,
    Types.Nvapp.Localgames.FindAndGetAppMetadataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'FindAndGetAppMetadata',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AddManualApplication: BridgeCommands.Command<
    Types.Nvapp.Localgames.AddManualApplicationParameters,
    Types.Nvapp.Localgames.AddManualApplicationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'AddManualApplication',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteManualApplication: BridgeCommands.Command<
    Types.Nvapp.Localgames.DeleteManualApplicationParameters,
    Types.Nvapp.Localgames.DeleteManualApplicationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'DeleteManualApplication',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAutoOptimizeEnabled: BridgeCommands.Command<
    {},
    Types.Nvapp.Localgames.GetAutoOptimizeEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'GetAutoOptimizeEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAutoOptimizeEnabled: BridgeCommands.Command<
    Types.Nvapp.Localgames.SetAutoOptimizeEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'SetAutoOptimizeEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const TriggerNGXUpdater: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'LocalGames',
    method: 'TriggerNGXUpdater',
    persistent: false
};

export const Localgames = {
GetApplications,
RegisterApplicationChangedNotifications,
RegisterApplicationRemovedNotifications,
StartApplicationScan,
RegisterApplicationScanProgressNotifications,
GetLastApplicationScanTime,
LaunchApplication,
LaunchApplicationByPath,
GetLauncherPID,
GetApplicationSearchPaths,
AddApplicationSearchPath,
RemoveApplicationSearchPath,
GetBatteryBoostState,
SetBatteryBoostState,
GetBatteryBoostSupportState,
GetIsSystemOPSCompatible,
GetIsMultiGPUInferenceSupported,
GetWhisperModeState,
SetWhisperModeState,
GetWhisperModeInfo,
RegisterWhisperModeStateNotifications,
GetWhisperModeSupportState,
RegisterWhisperModeSupportStateNotifications,
GetSettingsTranslations,
GetSettingsSpace,
SetTargetSettings,
GetApplicationState,
RegisterApplicationStateChangedNotifications,
RegisterMultiGPUStateChangedNotifications,
GetSignedGPUID,
LaunchMSSettings,
SetOOTBStatus,
FindAndGetAppMetadata,
AddManualApplication,
DeleteManualApplication,
GetAutoOptimizeEnabled,
SetAutoOptimizeEnabled,
TriggerNGXUpdater
};
